import type { LucideIcon } from 'lucide-react'
import type { ReactNode } from 'react'

interface EmptyStateProps {
  icon: LucideIcon
  title: string
  children?: ReactNode
  className?: string
}

export function EmptyState({ icon: Icon, title, children, className = '' }: EmptyStateProps) {
  return (
    <div className={`flex flex-col items-center px-4 py-10 text-center desk:py-14 ${className}`}>
      <span className="mb-3 inline-flex size-11 items-center justify-center rounded-xl bg-surface text-muted ring-1 ring-line ring-inset">
        <Icon size={20} />
      </span>
      <h2 className="text-base font-semibold">{title}</h2>
      {children && <div className="mt-1.5 max-w-md text-sm text-pretty text-muted">{children}</div>}
    </div>
  )
}
